function Choice({ register, choice, optionNum }) {
    const { id: choiceId } = choice;
    const { option, quizQuestionsId: questionId } = choice.attributes;

    return (
        <div>
            <input
                type="radio"
                id={choiceId}
                name={questionId}
                value={choiceId}
                className="hidden peer"
                {...register(`answer-${questionId}`)}
            />
            <label
                htmlFor={choiceId}
                className="flex items-center justify-start w-full p-5 text-blue-color-primary bg-white-color border border-gray-200 rounded-lg cursor-pointer peer-checked:border-primary-color-primary  peer-checked:bg-secondary-color
                 peer-checked:text-primary-color-light hover:text-blue-color-light hover:bg-gray-100  shadow-[rgba(17,_17,_26,_0.1)_0px_0px_16px]"
            >
                <span className="flex items-center justify-center mx-2 leading-5 border-2 rounded-full w-7 h-7 text-blue-color-primary bg-primary-color-light">
                    {optionNum + 1}
                </span>
                {option}
            </label>
        </div>
    );
}

export default Choice;
